import React, { useEffect, useRef, useState } from 'react';
import { FaInfoCircle } from 'react-icons/fa';

export default function InfoTip({ text, label = 'Mais informações' }) {
  const [open, setOpen] = useState(false);
  const holder = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const closeOutside = (event) => {
      if (holder.current && !holder.current.contains(event.target)) setOpen(false);
    };
    const closeEscape = (event) => { if (event.key === 'Escape') setOpen(false); };
    document.addEventListener('pointerdown', closeOutside);
    document.addEventListener('keydown', closeEscape);
    return () => {
      document.removeEventListener('pointerdown', closeOutside);
      document.removeEventListener('keydown', closeEscape);
    };
  }, [open]);

  return <span ref={holder}
    onMouseEnter={() => setOpen(true)}
    onMouseLeave={() => { if (document.activeElement !== holder.current?.querySelector('button')) setOpen(false); }}
    className="relative inline-flex shrink-0 align-middle">
    <button type="button" aria-label={label} aria-expanded={open} onClick={() => setOpen(value => !value)}
      onBlur={() => { if (!holder.current?.matches(':hover')) setOpen(false); }}
      className="inline-flex h-8 w-8 items-center justify-center rounded-full text-slate-400 transition hover:bg-blue-50 hover:text-blue-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-blue-600">
      <FaInfoCircle aria-hidden="true" size={14}/>
    </button>
    {open && <span role="tooltip" className="absolute right-0 top-full z-50 mt-1 w-[min(18rem,calc(100vw-3rem))] rounded-xl border border-slate-200 bg-slate-900 px-3 py-2 text-left text-xs font-normal leading-5 text-white shadow-xl">{text}</span>}
  </span>;
}
